import { z } from 'zod'

export default z.object({
  __typename: z.literal('StorageTransaction').default('StorageTransaction'),
  id: z.number(),
})
